<div
  *ngIf="
    organisationTypeId == OrganisationTypeEnum.Engineius ||
    organisationTypeId == OrganisationTypeEnum.Supplier
  "
  [class.ghost]="loadingTask"
  class="mt-3"
>
  <p-panel styleClass="panel-shadow">
    <p-header>
      <div class="w-full flex justify-content-between align-items-center">
        <div>Vehicle Details</div>
        <button
          pButton
          label="Change"
          class="ui-button-secondary"
          (click)="editVehicleVisible = true"
          *ngIf="organisationTypeId == OrganisationTypeEnum.Engineius"
        ></button>
      </div>
    </p-header>
    <div class="grid-label-value">
      <div class="item">
        <div class="label">Registration:</div>
        <div class="value ghost-fill">{{ selectedTask?.vehicle?.registrationNumber || '-' }}</div>
      </div>
      <div class="item">
        <div class="label">Make:</div>
        <div class="value ghost-fill">{{ selectedTask?.vehicle?.make || '-' }}</div>
      </div>
      <div class="item">
        <div class="label">Model:</div>
        <div class="value ghost-fill">{{ selectedTask?.vehicle?.model || '-' }}</div>
      </div>
      <div class="item">
        <div class="label">Fuel Type:</div>
        <div class="value ghost-fill">{{ selectedTask?.vehicle?.fuelType || '-' }}</div>
      </div>
      <div class="item">
        <div class="label">Transmission:</div>
        <div class="value ghost-fill">{{ selectedTask?.vehicle?.transmissionType || '-' }}</div>
      </div>
      <div class="item">
        <div class="label">Body:</div>
        <div class="value ghost-fill">{{ selectedTask?.vehicle?.body || '-' }}</div>
      </div>
      <div class="item">
        <div class="label">Color:</div>
        <div class="value ghost-fill">{{ selectedTask?.vehicle?.color || '-' }}</div>
      </div>
      <div class="item">
        <div class="label">Engine Size:</div>
        <div class="value ghost-fill">{{ selectedTask?.vehicle?.sizeEngine || '-' }}cc</div>
      </div>
      <div class="item">
        <div class="label">VIN:</div>
        <div class="value ghost-fill">{{ selectedTask?.vehicle?.vin || '-' }}</div>
      </div>
      <div class="item">
        <div class="label">Height:</div>
        <div class="value ghost-fill">{{ selectedTask?.vehicle?.height || '-' }}mm</div>
      </div>
      <div class="item">
        <div class="label">Kerb Weight:</div>
        <div class="value ghost-fill">{{ selectedTask?.vehicle?.kerbWeight || '-' }}kg</div>
      </div>
      <div class="item">
        <div class="label">Width:</div>
        <div class="value ghost-fill">{{ selectedTask?.vehicle?.width || '-' }}mm</div>
      </div>
      <div class="item">
        <div class="label">Value:</div>
        <div class="value ghost-fill">
          {{
            (selectedTask?.vehicle?.forecourtSale | currency : 'GBP' : 'symbol' : '1.2-2') ||
              'Not found'
          }}
        </div>
      </div>
      <!--      <div class="item">-->
      <!--        <div class="label">Wheelbase:</div>-->
      <!--        <div class="value ghost-fill">{{ selectedTask?.vehicle?.wheelbaseLength || '-' }}mm</div>-->
      <!--      </div>-->
    </div>
  </p-panel>
</div>

<job-screen-edit-vehicle-dialog
  [(visible)]="editVehicleVisible"
  [taskId]="selectedTask?.id"
  (vehicleUpdated)="onVehicleUpdated()"
>
</job-screen-edit-vehicle-dialog>
